import React, { useRef, useState, useLayoutEffect } from 'react'
import gsap from 'gsap'
import { useContext } from 'react'
import { StoreDispatch, StoreState } from '../../Store'
import { getExpeditionColors } from '../../utils/utils'
import { ExpeditionsMaskMain } from './index.style'
import { animation } from '../../styles/vars/animation.style'

const ExpeditionsMask = () => {
  const store = useContext(StoreState)
  const dispatch = useContext(StoreDispatch)
  const $mask = useRef()
  const tl = useRef()
  const cardIndex = useRef('1')
  const [maskColor, setMaskColor] = useState(
    getExpeditionColors(cardIndex.current).light
  )

  useLayoutEffect(() => {
    if (!store.expeditionCardIndex) return

    const setTransformOrigin = () => {
      const $cards = document.querySelectorAll('.expedition-card')

      if (!$cards.length) return

      const $card = $cards[parseInt(cardIndex.current) - 1]
      const cardDimensions = $card.getBoundingClientRect()
      const cardWidth = cardDimensions.width
      const cardHeight = cardDimensions.height
      const scaleX = cardWidth / window.innerWidth
      const scaleY = cardHeight / window.innerHeight
      const translateX = cardDimensions.left
      const translateY = cardDimensions.top

      setMaskColor(getExpeditionColors(cardIndex.current).light)

      gsap.set($mask.current, {
        scaleX: scaleX,
        scaleY: scaleY,
        x: translateX,
        y: translateY,
      })
    }

    const openAnimation = () => {
      const startDelay = 0.1
      const scaleDuration = 0.6
      const borderRadius = 6

      if (tl.current) {
        tl.current.kill()
      }

      tl.current = gsap.timeline({
        delay: startDelay,
      })

      const tlFillCard = gsap.timeline({
        onUpdate: () => {
          const scaleX = gsap.getProperty($mask.current, 'scaleX')
          const scaleY = gsap.getProperty($mask.current, 'scaleY')
          const border = `${parseInt(borderRadius / scaleX, 10)}px / ${parseInt(
            borderRadius / scaleY,
            10
          )}px`

          $mask.current.style.borderRadius = border
        },
      })
      const tlFillWindow = gsap.timeline()

      tlFillCard
        .set($mask.current, {
          opacity: 1,
        })
        .from($mask.current, {
          scaleY: 0,
          duration: scaleDuration,
          ease: 'power2.out',
        })

      tlFillWindow
        .to($mask.current, {
          x: 0,
          y: 0,
          scale: 1,
          borderRadius: 0,
          duration:
            animation.expeditionMaskDuration - startDelay - scaleDuration,
          ease: 'power3.inOut',
        })
        .set($mask.current, {
          clearProps: 'all',
          delay: animation.maskShowDuration,
          onComplete: () => {
            dispatch({ type: 'SET_EXPEDITION_CARD_INDEX', payload: null })
          },
        })

      tl.current.add(tlFillCard)
      tl.current.add(tlFillWindow)
    }

    cardIndex.current = store.expeditionCardIndex
    setTransformOrigin()
    openAnimation()
  }, [store.expeditionCardIndex, dispatch])

  return <ExpeditionsMaskMain ref={$mask} color={maskColor} />
}

export default ExpeditionsMask
